<h2 mat-dialog-title>
  Sélectionner un local provenant d'un projet
</h2>
<app-list-room
  [actions]="['select', 'search']"
  (select)="close($event)">
</app-list-room>
